common.View.create('shop::website.modules.shopCheckout.order.Index', {

    ajaxCalls: [],

    onDOMLoad()
    {
        //this.initShipping();
        this.initShippingOptions();

        this.initSameInvoiceAddress();
        this.initSubmit();
    },

    initShippingOptions() {
        // Get the fields that need to be listened to
        let fields = '[name="shipping[street]"], [name="shipping[house_number]"], [name="shipping[postal]"], ' +
            '[name="shipping[city]"], [name="shipping[country]"], [name="shipping_method"], ' +
            '[name="shipping[pickup_store][information]"]';

        // Find fields and add onchange event
        $(document).on('change', '.shop\\:\\:website-modules-shopCheckout-order-Index ' + fields, (event) => {
            this.initShippingOptionsPost();

            return false;
        });

        $(document).on('change', '.shop\\:\\:website-modules-shopCheckout-order-Index [name="payment_method"]', (event) => {
            this.initShippingOptionsPost(false);

            return false;
        });

        // Initialize on load
        this.initShippingOptionsPost();
    },

    initShippingOptionsPost(updateViews = true)
    {
        this.removeAjaxCalls();

        let ajaxCall = $.post('/set-shipping', this.element.find('form').serialize())
            .done((data) => {
                // Replace content
                if( updateViews ) {
                    for(const[key, value] of Object.entries(data)) {
                        this.element.find('.' + key).html(value);
                    }
                }

                // Update delivery price on evenings select
                this.updateDeliveryMethodPrice();
            });

        this.ajaxCalls.push(ajaxCall);
    },

    removeAjaxCalls()
    {
        for(const ajaxCall of this.ajaxCalls) {
            ajaxCall.abort();
            this.ajaxCalls.splice(this.ajaxCalls[ajaxCall], 1);
        }
    },

    updateDeliveryMethodPrice()
    {
        // Re-init views so ...Order-Shipping method common view gets updated
        common.View.reinit();

        // Reload totals
        this.reloadTotals();
    },

    reloadTotals()
    {
        // Reload totals
        $.post(this.element.data('url') +  '/calculate-totals', this.element.find('form').serialize())
            .done((data) => {
                this.element.find('.totals').html(data);
            });
    },

    reloadSigned()
    {
        // Reload totals
        $.post(this.element.data('url') +  '/reload-signed', this.element.find('form').serialize())
            .done((data) => {
                this.element.find('.signed').replaceWith(data);
            });
    },

    initShipping()
    {
        // Define variables
        const shippingData = {
            shippingSelect: this.element.find('.shop::website-Modules-ShopCheckout-Order-Shipping #shipping_method'),
            toChangeText: this.element.find('.shop::website-Modules-ShopCheckout-Order-Address .changeableText'),
            checkboxContainer: this.element.find('.checkboxSame'),
            shippingText: 'Bezorgadres',
            invoiceText: 'Factuuradres',
        };

        // Hook to change that function will fire
        shippingData.shippingSelect.change(() => this.manageShipping(shippingData));

        // Fire function once incase of old values
        this.manageShipping(shippingData);
    },

    manageShipping(shippingData)
    {
        // Define variables
        let checkbox = shippingData.checkboxContainer.find('input[type="checkbox"][name="invoice_same"]');

        // Check if value is 'Ophalen'
        if (shippingData.shippingSelect.val() === 'Ophalen') {
            // Set heading text
            shippingData.toChangeText.html(shippingData.invoiceText);

            // Check checkbox to make sure invoice data is the same as shipping data
            checkbox.prop('checked', true).trigger('change');

            // Hide checkbox container
            shippingData.checkboxContainer.addClass('hidden md:hidden');
        } else {
            // Set heading text
            shippingData.toChangeText.html(shippingData.shippingText);

            // Show checkbox container
            shippingData.checkboxContainer.removeClass('hidden md:hidden');
        }
    },

    initSameInvoiceAddress()
    {
        this.element

            // Listen for invoice same checkbox change.
            .find('input[name="invoice_same"]')
                .change(() => this.manageSameInvoiceAddress())
                .end();

        //
        this.manageSameInvoiceAddress();
    },

    manageSameInvoiceAddress()
    {
        // Show / hide invoice address.
        let invoiceAddressInstance = this.element.find('.shop\\:\\:website-modules-shopCheckout-order-Address[data-type="invoice"]').data('instance');

        // Determine if invoice address should be active.
        let invoiceTypeActive = !this.element.find('input[name="invoice_same"]').is(':checked');

        //
        invoiceAddressInstance.manageRequiredInvoiceType(invoiceTypeActive);
    },

    initSubmit()
    {
        this.element

            // Listen for form submit.
            .find('form')
                .on('submit', this.onFormSubmit.bind(this))
                .end();
    },

    onFormSubmit()
    {
        this.element

            // Show as loading.
            .addClass('cursor-wait')

            // Disable all inputs
            .find('input, select')
                .attr('readonly', true)
                .end()

            // Disable button(s).
            .find('button[type="submit"]')
                .attr('disabled', true)
                .end();
    },

    getShippingIndexInstance()
    {
        return shop.website.modules.shopCheckout.order.ShippingMethod.getInstance(this);
    }

});
